export default __webpack_public_path__ + "static/desktop-5b0af035d249f802dd558e3b6661d9d3.jpg";